import React, {useContext, useEffect} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import styled from 'styled-components';
import {UserContext} from '../../contexts/UserContext';

import {getConfig} from '../../config';

import AuthService from '../../services/AuthService';
import Authenticator from '../../common/components/Authenticator';
import Meta from '../../common/components/Meta';

const Wrapper = styled.div.withConfig({displayName:'-Wrapper'})`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  background: #F6F7FB;
`;

const Content = styled.div.withConfig({displayName:'-Content'})`
  text-align: center;
  width: 100%;
`;

const Auth = () => {
  // const [sessionUser, setSessionUser] = useState(null);
  // const [error, setError] = useState(null);
  const {setUser} = useContext(UserContext);
  let navigate = useNavigate();
  const {page} = useParams();

  useEffect(() => {
    // if(page === "login" || page === "registration" || page === "logout"){
      AuthService.logout();
      setUser(null);
    // }
  }, [page, setUser]);


  // if(page === "logout"){
  //   return (
  //     <Navigate to="/auth/login" />
  //   )
  // }else{
    return (
      <Wrapper>
        <Meta title={"Sign in"} />
        <Content>
          <Authenticator
            userPoolId={getConfig("cognitoPoolId")}
            identityPoolId={"eu-west-1:419a97ed-b5e5-415e-817d-36e5cb48ec8a"}
            clientId={getConfig("cognitoClientId")}
            region={getConfig("cognitoRegion")}
            onSuccess={(response)=> {
              localStorage.setItem(getConfig("userLocalStorage"), JSON.stringify(response));
              setUser(response);
              navigate("/");
            }}
            entryPoint={page}
            enableRegistration={false}
          />
        </Content>
      </Wrapper>
    )
  // }
}

export default Auth;
